import KratosVerification from "../src/components/Authentication/Kratos/KratosVerification";

export default function Verification() {
  return <KratosVerification />;
}
